// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fQia","content":"styles_content__29HpY"};